<template>
  <div class="listen" v-scroll-to="goScroll">
    <!-- <audio preload="auto" :src="list.listenAudio" ref="audio"></audio> -->
    <div class="layout" style="padding-top: 64px">
      <!--<Layout>-->
      <Head :headerNum="3" />
      <Card style="width: 1000px;margin:20px auto" v-if="list.originalList">
        <div class="card-top">
          <h1 slot="title" class="title">
            <img
              src="/static/img/cambrdge20190124.png"
              style="width: 27px;height: 30px"
            />
            剑桥雅思
          </h1>
          <div class="card-top-mid">
            <ul @click="back()">
              <li class="point">剑雅{{ this.$route.params.camNum }}</li>
              <li class="point">TEST {{ this.$route.params.testNum }}</li>
              <li class="point" style="color:#b3b3b3;font-weight: normal;">
                Section {{ this.$route.params.sectionNum }}
              </li>
            </ul>
          </div>
          <div class="card-top-right">
            <ul>
              <li class="point">
                <img
                  src="/static/img/collect_grey20190124.png"
                  alt=""
                  class="icon-img"
                />
                <span>未收藏</span>
              </li>
              <li class="point" @click="goTest()">
                <img
                  src="/static/img/go_ex20190124.png"
                  alt=""
                  class="icon-img"
                />
                <span>去练习</span>
              </li>
              <li class="point">
                <img
                  src="/static/img/key_guide20190124.png"
                  alt=""
                  class="icon-img"
                />
                <span>快捷键</span>
              </li>
            </ul>
          </div>
          <a href="javascript:" style="visibility: hidden">
            <Icon type="ios-close" class="close" />
          </a>
        </div>

        <div class="card-content">
          <div class="content-top">
            <!-- <div class="player">
                <img src="./../Listenlist/img/play20190124.png" alt="" style="width: 42px;height: 42px;cursor: pointer;" @click="playAudio(true)" v-if="!isPlay">
                <img src="./../Listenlist/img/stop20190124.png" alt="" style="width: 42px;height: 42px;cursor: pointer;" @click="playAudio(false)" v-else>
                <Slider  @on-change="changeTime"	 v-model="value1" style="width: 570px;padding-left: 10px;" :tip-format="hideFormat" :max="10000"></Slider>
                <span style="padding-left: 25px;color: #b3b3b3;">{{startTime}}/{{endTime}}</span>
                <Button shape="circle" type="info" style="height: 24px;margin-left: 15px;" size="small" @click="changeSpeed()">X{{speed[speedItem]}}</Button>
              </div> -->
            <player
              v-show="!playMod"
              :playNum="playNum"
              :playItem="playItem"
              ref="player"
              :list="list"
              :audioUrl="list.listenAudio"
              :playTab="playTab"
              :collectionIndex="collectionIndex"
              v-on:sendTime="sendTime"
              v-on:isPlays="isPlays"
              :spacingItem="spacingItem"
            />
            <div class="player-right" v-show="!playMod">
              <p>
                <span @click="changeTab(true)" :class="playTab ? 'playtab' : ''"
                  >全文</span
                >
                <span
                  @click="changeTab(false)"
                  :class="!playTab ? 'playtab2' : ''"
                  >标记</span
                >
              </p>
            </div>
          </div>
          <div class="content-menu">
            <ul>
              <li>
                <p
                  style="width:24px;height:24px;border-radius:50%"
                  class="selectp content-menu-p"
                >
                  标
                </p>
              </li>
              <li>
                <p
                  style="color: #b3b3b3;background:none;width:auto"
                  class="content-menu-p"
                >
                  第{{ playNum }}/{{ list.originalList.length }}句
                </p>
              </li>
              <li
                @click="
                  isHideText = !isHideText;
                  showTextList = [];
                "
              >
                <p
                  :class="{ selectp: isHideText ? false : true }"
                  class="content-menu-p"
                >
                  文本
                </p>
              </li>
              <li @click="showTranslation()">
                <p
                  class="content-menu-p"
                  :class="{ selectp: !isTranslation ? false : true }"
                >
                  翻译
                </p>
              </li>
            </ul>
          </div>

          <div class="content-content scroll-ul" style="padding-left: 15px;">
            <GeminiScrollbar class="my-scroll-bar">
              <ul v-show="!playMod && playItem !== 5">
                <!-- 顺序播放-->
                <li
                  v-for="(item, index) in list.originalList"
                  :key="index"
                  :id="'element' + index"
                  v-if="
                    playTab ||
                      !collectionIndex.length ||
                      collectionIndex.includes(index)
                  "
                >
                  <img
                    style="cursor: pointer"
                    class="icon-img"
                    :src="
                      collectionIndex.includes(index)
                        ? '/static/img/mark_20190124.png'
                        : '/static/img/mark_grey20190124.png'
                    "
                    @click="collection(index)"
                  />
                  <div>
                    <p
                      @click="
                        showText(
                          index,
                          item.listenList[0].timeBeg,
                          item.listenList[0].timeEnd
                        )
                      "
                      :class="{
                        hidetext:
                          isHideText && !showTextList.includes(index)
                            ? true
                            : false
                      }"
                      class="content-content-p"
                      :style="
                        valCom(
                          index,
                          item.listenList[0].timeBeg,
                          item.listenList[0].timeEnd
                        )
                      "
                    >
                      {{ item.listenList[0].original }}
                    </p>
                    <p
                      v-if="isTranslation"
                      class="content-content-p"
                      style="padding-top: 10px"
                    >
                      {{ item.listenList[0].translation }}
                    </p>
                  </div>
                </li>
              </ul>

              <ul
                v-show="playMod && playItem !== 5"
                style="display: flex;flex-direction: column;justify-content: center;position: relative;"
              >
                <li
                  v-for="(item, index) in list.originalList"
                  :key="index"
                  :id="'element' + index"
                  v-if="
                    valCom(
                      index,
                      item.listenList[0].timeBeg,
                      item.listenList[0].timeEnd
                    )
                  "
                >
                  <img
                    style="cursor: pointer"
                    class="icon-img"
                    :src="
                      collectionIndex.includes(index)
                        ? '/static/img/mark_20190124.png'
                        : '/static/img/mark_grey20190124.png'
                    "
                    @click="collection(index)"
                  />
                  <div>
                    <p
                      :class="{ hidetext: isHideText ? true : false }"
                      class="content-content-p"
                      :style="
                        valCom(
                          index,
                          item.listenList[0].timeBeg,
                          item.listenList[0].timeEnd
                        )
                      "
                    >
                      {{ item.listenList[0].original }}
                    </p>
                    <p
                      v-if="isTranslation"
                      class="content-content-p"
                      style="padding-top: 10px"
                    >
                      {{ item.listenList[0].translation }}
                    </p>
                  </div>

                  <!-- 单句播放按钮-->
                  <div
                    class="one-con-abs"
                    style="position: absolute;bottom: 0;width: 100%;"
                  >
                    <div
                      class="one-con"
                      style="display: flex;flex-direction: column;align-items: center"
                    >
                      <img
                        v-if="!isPlaying"
                        src="/static/img/play2_190214.png"
                        style="width: 50px;height: 50px;cursor: pointer"
                        @click="playOne(index, isPlaying)"
                      />
                      <p
                        v-if="!isPlaying"
                        style="color: #3399ff;font-size: 20px;cursor: pointer"
                        @click="playOne(index, isplayOne)"
                      >
                        播放
                      </p>
                      <img
                        v-if="isPlaying"
                        src="/static/img/stop2_190214.png"
                        style="width: 50px;height: 50px;cursor: pointer"
                        @click="playOne(index, isPlaying)"
                      />
                      <p
                        v-if="isPlaying"
                        style="color: #3399ff;font-size: 20px;cursor: pointer"
                        @click="playOne(index, isplayOne)"
                      >
                        暂停
                      </p>
                    </div>
                  </div>

                  <!-- 听写模式 -->
                </li>
              </ul>

              <ul
                v-show="playItem === 5"
                style="display: flex;flex-direction: column;justify-content: center;position: relative;"
              >
                <div
                  class="write"
                  style="display: flex;align-items: center;margin-bottom: 60px;"
                >
                  <p
                    style="width:24px;height:24px;border-radius:50%"
                    class="selectp content-menu-p"
                  >
                    写
                  </p>
                  <Input
                    v-model="writeValue"
                    :autosize="{ minRows: 2, maxRows: 2 }"
                    type="textarea"
                    style="width:800px;margin-left: 20px;padding-left: 10px;"
                    placeholder="Enter something..."
                  />
                </div>

                <li
                  v-for="(item, index) in list.originalList"
                  :key="index"
                  :id="'element' + index"
                  v-if="
                    valCom(
                      index,
                      item.listenList[0].timeBeg,
                      item.listenList[0].timeEnd
                    )
                  "
                >
                  <img
                    style="cursor: pointer"
                    class="icon-img"
                    :src="
                      collectionIndex.includes(index)
                        ? '/static/img/mark_20190124.png'
                        : '/static/img/mark_grey20190124.png'
                    "
                    @click="collection(index)"
                  />
                  <div>
                    <p
                      :class="{ hidetext: isHideText ? true : false }"
                      class="content-content-p"
                      :style="
                        valCom(
                          index,
                          item.listenList[0].timeBeg,
                          item.listenList[0].timeEnd
                        )
                      "
                    >
                      {{ item.listenList[0].original }}
                    </p>
                    <p
                      v-if="isTranslation"
                      class="content-content-p"
                      style="padding-top: 10px"
                    >
                      {{ item.listenList[0].translation }}
                    </p>
                  </div>

                  <!-- 听写按钮-->
                </li>
                <div
                  class="one-con-abs"
                  style="position: absolute;bottom: 0;width: 100%;"
                >
                  <div
                    class="one-con"
                    style="display: flex;flex-direction: column;align-items: center"
                  >
                    <div
                      style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 20px"
                    >
                      <!--<div class="one-con-listen" @click="isHideText = !isHideText;showTextList=[]">
                          <img  v-if="isHideText" src="/static/img/text_on20190124.png" style="width: 50px;height: 43px;cursor: pointer">
                          <p v-if="isHideText" style="color: #3399ff;font-size: 20px;cursor: pointer">显示</p>
                          <img v-if="!isHideText" src="/static/img/text_off20190124.png" style="width: 50px;height: 43px;cursor: pointer">
                          <p v-if="!isHideText" style="color: #3399ff;font-size: 20px;cursor: pointer">隐藏</p>
                        </div>
-->
                      <div class="one-con-listen">
                        <img
                          v-if="!isPlaying"
                          src="/static/img/play2_190214.png"
                          style="width: 50px;height: 50px;cursor: pointer"
                          @click="playOne(index, isPlaying)"
                        />
                        <p
                          v-if="!isPlaying"
                          style="color: #3399ff;font-size: 20px;cursor: pointer"
                          @click="playOne(index, isplayOne)"
                        >
                          播放
                        </p>
                        <img
                          v-if="isPlaying"
                          src="/static/img/stop2_190214.png"
                          style="width: 50px;height: 50px;cursor: pointer"
                          @click="playOne(index, isPlaying)"
                        />
                        <p
                          v-if="isPlaying"
                          style="color: #3399ff;font-size: 20px;cursor: pointer"
                          @click="playOne(index, isplayOne)"
                        >
                          暂停
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ul>
            </GeminiScrollbar>
          </div>
        </div>

        <div class="card-bottom">
          <ul class="bottom-ul">
            <li
              @click="next(false)"
              v-if="value1 > list.originalList[0].listenList[0].timeBeg"
            >
              <img src="/static/img/last_b_190214.png" /> <span>上一句</span>
            </li>
            <li v-else>
              <img src="/static/img/last_g_190214.png" /> <span>上一句</span>
            </li>
            <li @click="changeSpacing()">
              <!--<h1 style="font-size: 20px;height: 28px;">{{spacing[spacingItem]}}s</h1>-->
              <img :src="spacing[spacingItem]" v-if="playItem !== 0" />
              <img src="/static/img/x_190308.png" v-if="playItem === 0" />
              <span>间隔</span>
            </li>
            <li>
              <Dropdown
                trigger="click"
                style="display: flex;flex-direction: column"
                @on-click="changePlayMod"
              >
                <img :src="playList[playItem].img" />
                <span>{{ playList[playItem].text }}</span>
                <DropdownMenu slot="list">
                  <DropdownItem
                    v-for="(item, index) in playList"
                    :name="index"
                    :key="index"
                    >{{ item.text }}</DropdownItem
                  >
                </DropdownMenu>
              </Dropdown>
            </li>
            <li @click="changePlayOrder">
              <img
                :src="
                  !playMod
                    ? '/static/img/ciecle_190214.png'
                    : '/static/img/sigle_190214.png'
                "
              />
              <span>{{ !playMod ? "全文" : "单句" }}</span>
            </li>
            <li
              @click="next(true)"
              v-if="
                value1 <
                  list.originalList[list.originalList.length - 1].listenList[0]
                    .timeBeg
              "
            >
              <img src="/static/img/next_b_190214.png" /> <span>下一句</span>
            </li>
            <li v-else>
              <img src="/static/img/next_g_190214.png" /> <span>下一句</span>
            </li>
          </ul>
        </div>
      </Card>
    </div>
    <!--{{}}-->
  </div>
</template>

<script>
import { scrollAnimation } from "../../../static/js/scroll";
import ajax from "./../../api/ajax";
import Player from "./../../components/Player";
import Head from "./../../components/Head";
export default {
  name: "Listen",
  data() {
    return {
      value1: 0, //当前播放时间
      list: [], //总数据
      url: "https://winielts.com",
      playList: [
        {
          img: "/static/img/mt.png",
          text: "顺序播放"
        },
        {
          img: "/static/img/m1.png",
          text: "单句播放"
        },
        {
          img: "/static/img/m2.png",
          text: "单句两遍"
        },
        {
          img: "/static/img/m5.png",
          text: "单句五遍"
        },
        {
          img: "/static/img/mi.png",
          text: "单句循环"
        },
        {
          img: "/static/img/md.png",
          text: "听写模式"
        }
      ],
      playMod: false, //模仿模式单句还是顺序
      playItem: 0, //播放模式索引
      collectionIndex: [], //已经收藏的索引
      playNum: 0, //当前播放第几句
      spacing: [
        "/static/img/0s_190214.png",
        "/static/img/2s_190214.png",
        "/static/img/5s_190214.png"
      ],
      spacingItem: 0, //当前第几个间隔
      isHideText: false, // 是否隐藏文本
      showTextList: [], //展示的句子
      isTranslation: false, //是否展示翻译
      isplayOne: true, //是否正在播放单句
      playTab: true, //播放模式是全文还是标记
      isPlaying: false, //是否正在播放音频
      writeValue: "" //听写填写的内容
    };
  },
  components: {
    Player,
    Head
  },
  async mounted() {
    await this.getData();
    document.body.addEventListener(
      "touchmove",
      function(e) {
        e.preventDefault();
      },
      { passive: true }
    );
    await this.loading();
  },
  computed: {
    // playNumCom(){  //当前播放
    //   // let playItem = 0
    //   let currentTime = this.value1
    //   this.list.originalList.forEach((item,index)=>{
    //     // console.log(index);
    //     let startTime = item.listenList[0].timeBeg
    //
    //     let endTime = item.listenList[0].timeEnd
    //
    //     if(currentTime >= startTime && currentTime < endTime){
    //
    //           this.playNum = index  + 1
    //
    //     }
    //   })
    //   return this.playNum
    // },
    goScroll() {
      if (this.isPlaying) {
        return {
          el: "#element" + this.playNum,
          container: ".scroll-ul",
          duration: 10,
          easing: "ease",
          offset: -200,
          force: false,
          cancelable: true,
          x: false,
          y: true,
          abortEvents: "mousedown"
        };
      } else {
        return {};
      }
    },
    valCom() {
      return function(index, start, end) {
        let currentTime = this.value1;
        let num = 0;
        if (currentTime >= start && currentTime < end && !this.isHideText) {
          if ((this.playItem === 0 && this.playItem !== 5) || !this.isPlaying) {
            this.playNum = index + 1;
            console.log(index);
          }
          return {
            color: "#0080ff"
          };
        } else if (
          currentTime > start &&
          currentTime < end &&
          this.isHideText &&
          !this.showTextList.includes(index)
        ) {
          //不显示文本播放
          if ((this.playItem === 0 && this.playItem !== 5) || !this.isPlaying) {
            this.playNum = index + 1;
          }
          return {
            background: "rgb(127,191,255)",
            color: "rgb(127,191,255)",
            cursor: "pointer"
          };
        } else if (
          currentTime > start &&
          currentTime < end &&
          this.isHideText &&
          this.showTextList.includes(index)
        ) {
          return {
            color: "#0080ff"
          };
        }
      };
    },
    isCollectionCom() {
      this.collectionIndex.forEach(item => {
        console.log(item);
        return item;
      });
    }
  },
  watch: {
    playNum(num) {
      // console.log(num);
      if (num < 5) {
        document.getElementById(`element1`).scrollIntoView();
      } else {
        document.getElementById(`element${num - 4}`).scrollIntoView();
      }
    }
  },
  methods: {
    back() {
      this.$Modal.confirm({
        title: "返回",
        content: "<p>即将返回，是否确认？</p>",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.$router.go(-1);
        }
      });
    },
    loading() {
      if (this.list.originalList.length === 0) {
        this.$Message.error("暂无数据，即将返回上一页");
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      }
    },
    goTest() {
      this.$Modal.confirm({
        title: "练习",
        content: "<p>即将进入练习，是否确认？</p>",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.$router.push({
            name: "exercise",
            params: {
              camNum: this.$route.params.camNum,
              testNum: this.$route.params.testNum,
              sectionNum: this.$route.params.sectionNum
            }
          });
        }
      });
    },
    isPlays(v) {
      this.isPlaying = v;
    },
    changeTab(flag) {
      //全文还是标记
      if (this.playTab != flag) {
        if (!flag && this.collectionIndex.length === 0) {
          this.$Message.warning("先标记句子后再来精听重点句吧~");
          return;
        }
        if (flag) {
          this.$Message.success(
            `已切换到全文精听，共${this.list.originalList.length}句`
          );
        } else {
          this.$Message.success(
            `已切换到精听我标记的句子，共${this.collectionIndex.length}句`
          );
        }
      }
      this.playTab = flag;
    },
    playOne(index, isPlay) {
      //单句播放
      this.isPlaying = !this.isPlaying;
      this.$refs.player.playOnes(index, isPlay);
    },
    showTranslation() {
      this.isTranslation = !this.isTranslation;
    },
    changePlayMod(val) {
      this.playItem = val;
      if (val === 5) {
        this.playMod = true;
      } else {
        this.playMod = false;
      }
    },
    showText(index, start, end) {
      if (!this.isHideText) {
        //如果没有隐藏文本
        this.playNum = index + 1;
        this.$refs.player.playText(index, start, end);
      } else {
        //隐藏文本之后点击显示
        if (this.showTextList.indexOf(index) != -1) {
          let i = this.showTextList.indexOf(index);
          this.showTextList.splice(i, 1);
        } else {
          this.showTextList.push(index);
        }
        console.log(this.showTextList);
      }
    },
    changePlayOrder() {
      if (this.playItem !== 5) {
        this.playMod = !this.playMod;
      }
    },
    // hideText(){
    //   this.isHideText = !this.isHideText
    // },
    changeSpacing() {
      if (this.playItem === 0) {
        return;
      }
      this.spacingItem++;
      if (this.spacingItem === this.spacing.length) {
        this.spacingItem = 0;
      }
    },
    next(flag) {
      this.writeValue = "";
      this.$refs.player.nextSentence(flag);
    },
    collection(index) {
      //点击收藏
      if (this.collectionIndex.indexOf(index) != -1) {
        let i = this.collectionIndex.indexOf(index);
        this.collectionIndex.splice(i, 1);
      } else {
        this.collectionIndex.push(index);
      }
      this.collectionIndex.sort((a, b) => {
        return a - b;
      }); //ES6数组大小排序
      console.log(this.collectionIndex);
    },
    sendTime(val) {
      this.value1 = val;
    },
    async getData() {
      if (window.__PRERENDER_INJECTED) {
        throw "PrerenderSPAPlugin render";
      }
      this.$Spin.show({
        render: h => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 18
              }
            }),
            h("div", "Loading")
          ]);
        }
      });
      // const list = await ajax(this.url+'/api/ieltsCategory/categoryListen',{id:this.$route.params.id})
      const list = await ajax(this.url + "/api/ieltsCategory/categoryListen", {
        id: this.$route.params.id
      });
      this.list = list.data;
      // console.log(this.list);
      this.$Spin.hide();
      // console.log(list.data.originalList.length);
    }
  }
};
</script>

<style>
.gm-scrollbar-container .gm-scroll-view {
  overflow-y: scroll;
  overflow-x: inherit;
  /*overflow: inherit;*/
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.gm-scrollbar .thumb {
  background-color: #f2f2f2 !important;
}
.ivu-dropdown-rel {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
<style scoped lang="stylus">
.one-con-listen
  display: flex
  align-items: center
  flex-direction: column
  p
    padding-top 10px
.close
  font-size:40px
  color #b3b3b3
  cursor pointer
.listen
  height 100%
  background #f5f7f9
  min-width 1050px
  /*height 2000px*/
.content-top
  display flex
  align-items center
  margin-top 20px
  .player
    display: flex
    width: 800px
    align-items: center
    border: 1px solid #e5efff
    border-radius: 25px;
    padding 2px 10px
  .player-right
    margin-left 50px
    p
      cursor pointer
      border: solid 1px #7fbfff;
      width: 80px;
      height: 24px;
      border-radius: 12px;
      display flex
      align-items center
      span
        text-align center
        width: 40px;
        height: 24px;
        line-height 24px
        color: #3d9eff;
      .playtab
        border-radius: 12px 0px 0px 12px;
        background #3399ff
        color #fff
      .playtab2
        border-radius: 0px 12px 12px 0px;
        background #3399ff
        color #fff
.my-scroll-bar{
    height: 490px;
    margin 15px 0
}
.point
  cursor pointer
.content-content
  ul
    height: 490px;
    li
      display flex
      align-items center
      padding 15px 0
      width:900px
.content-content-p
  margin-left: 20px;
  padding-left: 10px;
  color #333
  cursor pointer
.hidetext
  background-color: #e6e6e6
  color: #e6e6e6
  border-radius 15px
.selectp
  background-color: #e5efff;
.content-menu-p
  color: #3d9eff;
  font-size 12px
  padding 5px
  border-radius 100%
  text-align center
  width 50px
  border-radius: 12px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content center
  cursor pointer
.content-menu
  margin-top 16px
  ul
    display flex
    li
      padding 0 15px

.layout
  border-bottom: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  height: 100%;
.card-bottom
  border-top: 1px solid #f2f2f2
  border-radius 0.5px
  padding-top: 16px
.card-content
  height: 600px

.card-top
  display: flex
  border-bottom: 1px solid #f2f2f2
  border-radius 0.5px
  /*justify-content space-between*/
  align-items: center
  height: 50px;
  padding-bottom: 16px;
  .card-top-mid
    margin-right: 200px;
    margin-left: 30px
    ul
      display: flex
      align-items: center
      height: 100%
      li
        padding 0 15px
        font-size: 14px;
        color: #ffbf7f;
        font-weight: bold
.card-top-right
  ul
    display: flex
    align-items: center
    height: 100%
    li
      display: flex
      align-items: center
      height: 100%
      padding 0 10px
      span
        padding-left: 6px
.icon-img
  width: 22px
  height: 22px
.bottom-ul
  display: flex
  justify-content: space-evenly;
  width: 60%;
  margin: 0 auto;
  li:hover
    /*background #eee*/
    /*animation:pulse 1s infinite*/
  li
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    cursor pointer
    width: 100%
    @keyframes pulse
      from
        -webkit-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
      50%
        -webkit-transform: scale3d(1.05, 1.05, 1.05);
        transform: scale3d(1.05, 1.05, 1.05);
      to
        -webkit-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    img
      height 28px
      width 28px
    span
      color: #7f7f7f
      font-size: 14px
      padding-top 10px
html
  font-size: 10px
.bottom-img
  border-top:1px solid #e8eaec
  height 40px
  img
    width: 8.4rem
    margin: 0px auto;
    display: block;
    height: 2rem;
    display: block;
    margin-top:1.2rem
.content
  position: relative
  h1
    position: absolute
    left: 0
    top: 0
  ul
    padding-top  5rem
    li
      display: flex
      justify-content: space-between
      height: 4rem
      align-items: center
      .li-left
        display: flex
      .li-right
        button
          margin 0 0.5rem

.select
  background #ff952b
  p
    color: #fff
.list-ul
  display: flex
  justify-content: space-evenly;
  li
    padding 0 1.2rem
    cursor: pointer
    border-radius: 14px;
    height: 28px
    display: flex
    align-items: center
    margin 0 10px
  li:hover
    background #ff952b
  li:hover p
    color  #fff
    p
      color: #ff8c19;
      font-size: 1.4rem;
.title
  font-size: 2rem;
  color: #333333;
  display: flex;
  align-items: center;
.Listenlist
  height: 100%
  width: 100%
  background-color: #f7f7f7!important;
.layout{
  // border-bottom: 1px solid #d7dde4;
  // background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  // overflow: hidden;
}
.layout-header-bar{
  background: #fff;
  box-shadow: 0 1px 1px rgba(0,0,0,.1);
}
.menu-item span{
  display: inline-block;
  overflow: hidden;
  width: 69px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width .2s ease .2s;
}
.menu-item i{
  transform: translateX(0px);
  transition: font-size .2s ease, transform .2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.collapsed-menu span{
  width: 0px;
  transition: width .2s ease;
}
.collapsed-menu i{
  transform: translateX(5px);
  transition: font-size .2s ease .2s, transform .2s ease .2s;
  vertical-align: middle;
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Listen/Listen.vue